/**
 * OV Gift Progress Bar - claim buttons, auto-removal of gifts whose tier is
 * no longer met, and quantity capping (free gifts are limited to 1 per order
 * because the backing 100%-off discount has no native quantity cap).
 * Part of the Rebuy rebuild.
 */
(function () {
  if (window.ovGiftBarInit) return;
  window.ovGiftBarInit = true;

  async function refreshDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.refresh === 'function') {
      await drawer.refresh(true);
    }
  }

  let adjusting = false;
  async function scanAdjustments() {
    if (adjusting) return;
    const el = document.querySelector('[data-ov-remove-line], [data-ov-cap-line]');
    if (!el) return;
    adjusting = true;
    const lineKey = el.dataset.ovRemoveLine || el.dataset.ovCapLine;
    const quantity = el.dataset.ovRemoveLine ? 0 : 1;
    try {
      const res = await fetch(`${theme.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity })
      });
      if (res.ok) await refreshDrawer();
    } catch (e) {
      console.log('[ov-gift-bar]', e); // eslint-disable-line
    }
    adjusting = false;
    setTimeout(scanAdjustments, 150);
  }

  document.addEventListener('click', async (evt) => {
    const btn = evt.target.closest('.ov-gift-claim');
    if (!btn || btn.disabled) return;
    evt.preventDefault();

    let variantId = btn.dataset.variantId;
    if (!variantId) {
      const option = btn.closest('.ov-gift-option');
      const sel = option ? option.querySelector('.ov-gift-variant') : null;
      if (sel) variantId = sel.value;
    }
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    try {
      const res = await fetch(`${theme.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId, 10),
            quantity: 1,
            properties: { _ov_free_gift: btn.dataset.tier }
          }]
        })
      });
      if (!res.ok) throw new Error(res.status);
      await refreshDrawer();
    } catch (e) {
      console.log('[ov-gift-bar]', e); // eslint-disable-line
      btn.disabled = false;
      btn.textContent = 'Try again';
      setTimeout(() => { btn.textContent = originalText; }, 2500);
    }
  });

  const observer = new MutationObserver(() => {
    clearTimeout(window.__ovGiftScanTimer);
    window.__ovGiftScanTimer = setTimeout(scanAdjustments, 400);
  });

  function arm() {
    const drawer = document.getElementById('cart-drawer');
    if (drawer) observer.observe(drawer, { childList: true, subtree: true });
    scanAdjustments();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
}());